<template>
  <v-app>
    <v-container>
      <v-row>
        <v-col
          v-if="$vuetify.breakpoint.mdAndUp"
          cols="7"
          class="d-flex justify-center black"
        >
          <div class="d-flex align-center justify-center">
            <v-img
              src="@/assets/atinet.png"
              contain
              style="width: 40%; height: 40%"
            ></v-img>
          </div>
        </v-col>
        <v-col
          cols="5"
          :class="[$vuetify.breakpoint.mdAndUp ? 'lg:3' : '', $vuetify.breakpoint.xsOnly ? 'col-12' : '']"
          class="d-flex align-center justify-center"
        >
          <v-row no-gutters class="align-start">
            <v-col
              cols="12"
              class="login-part d-flex align-center justify-center flex-column"
            >
              <div class="login-wrapper pt-md-4 pt-0">
                <!-- <v-tabs grow> -->
                <!-- <v-tabs-slider></v-tabs-slider> -->
                <!-- <v-tab :href="`#tab-login`">
                    
                  </v-tab> -->
                <!-- <v-tab :href="`#tab-newUser`">
                    New User
                  </v-tab> -->

                <!-- <v-tab-item  > -->
                <v-form>
                  <v-container>
                    <v-row class="flex-column">
                      
                      <v-col cols="12" class="d-flex align-center my-8">
                        
                        <v-col>
                          <!-- <v-img src="@/assets/atinet.png" contain style="height:650px"></v-img> -->
                          <div class="position-relative">
                           
                          <p
                            class="login-slogan display-2 text-center font-weight-medium mt-10"
                          >
                            Bienvenido
                          </p>
                          <p
                            class="login-slogan display-1 text-center font-weight-medium mb-10"
                          >
                            Control de equipos
                          </p>
                        </div>
                        </v-col>
                      </v-col>
                      <v-form ref="loginForm" @submit.prevent="loginMethod">
                        <v-col>
                          <v-text-field
                            v-model="email"
                            value="admin@flatlogic.com"
                            label="E-mail"
                            required
                          ></v-text-field>
                          <v-text-field
                            v-model="password"
                            :rules="passRules"
                            :type="show1 ? 'text' : 'password'"
                            label="Password"
                            hint="At least 6 characters"
                            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                            @click:append="show1 = !show1"
                            required
                          ></v-text-field>
                          <p
                            v-if="errorMessage"
                            style="color: red; font-size: 14px"
                          >
                            El nombre de usuario o contraseña son incorrectos.
                            Inténtelo de nuevo.
                          </p>
                        </v-col>
                        <v-col class="d-flex justify-space-between">
                          <v-btn
                            type="submit"
                            class="text-capitalize"
                            large
                            :disabled="
                              password.length === 0 || email.length === 0
                            "
                            color="primary"
                            @click="loginMethod()"
                          >
                            > Iniciar Sesión</v-btn
                          >
                          <v-btn
                            large
                            text
                            class="text-capitalize primary--text"
                            >Recuperar Contraseña</v-btn
                          >
                        </v-col>
                      </v-form>
                    </v-row>
                  </v-container>
                </v-form>
                <!-- </v-tab-item> -->

                <!-- </v-tabs> -->
              </div>
            </v-col>
            <v-col
              cols="12"
              class="d-flex justify-center"
              style="display: flex; align-items: end"
            >
              <v-footer style="display: flex; align-items: end">
                <div class="primary--text">
                  © 2022
                  <a href="https://flatlogic.com/" class="text-decoration-none"
                    >Ezequiel Flores</a
                  >, All rights reserved.
                </div>
              </v-footer>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>
<script>
import { loginFirebase } from "../../..../../database.js";
// import EquipoStore from "../store/index";
import { mapState } from "vuex";

export default {
  name: "Login",
  data() {
    return {
      email: "",
      password: "",
      show1: false,
      errorMessage: false,
      passRules: [
        (v) => !!v || "Password is required",
        (v) => v.length >= 6 || "Min 6 characters",
      ],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
    };
  },
  computed: {
    ...mapState({
      userlogged: (state) => state.userLogged,
      // filteredUsers: state => state.users.filter(user => user.active)
    }),
  },

  methods: {
    loginMethod() {
      loginFirebase(this.email, this.password)
        .then((userCredential) => {
          // Inicio de sesión exitoso
          const user = userCredential.user;
          //  console.log("User: ", user.email);
          console.log("Successfully registered!");
          this.$store.commit("SET_USER_LOGGED", user.email);
          console.log("User loged: ", this.userlogged);
          this.$router.push({
            name: "HomeView",
            params: { email: this.email },
          });
        })
        .catch((error) => {
          // Error al iniciar sesión
          const errorCode = error.code;
          const errorMessage = error.message;
          console.log("Error: ", errorCode, errorMessage);
          this.errorMessage = true;
        });
    },
    // created() {
    //   if (window.localStorage.getItem('authenticated') === 'true') {
    //     this.$router.push('/optix');
    //   }
    // }
  },
};
</script>
<!-- <style src="./Login.scss" lang="scss"/> -->
